import React, { useEffect } from 'react'
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { Landing } from '../components/Landing'
import { HorecaPage } from '../components/HorecaPage'
import { CookiePolicyPage } from '../components/CookiePolicyPage'
import { useLanguage } from '../services/LanguageContextProvider'
import { localeFromPathname } from '../i18n/locales'

// Keeps i18next + LanguageContext in sync with the URL (the source of truth).
// Mounted inside the router so it can read the active pathname.
const LocaleSync = () => {
  const { pathname } = useLocation()
  const { i18n } = useTranslation('global')
  const { language, setNewLanguage } = useLanguage()

  useEffect(() => {
    const locale = localeFromPathname(pathname)
    if (i18n.language !== locale) i18n.changeLanguage(locale)
    if (language !== locale) setNewLanguage(locale)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return null
}

// Smooth-scrolls to #section when navigating with a hash (nav links from any
// route resolve to "<localized-home>#section"). v6 doesn't do this natively.
const ScrollToHash = () => {
  const { hash, pathname } = useLocation()

  useEffect(() => {
    if (!hash) return
    const el = document.getElementById(hash.slice(1))
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }, [hash, pathname])

  return null
}

export const Router = () => {
    return (
        <BrowserRouter>
            <LocaleSync />
            <ScrollToHash />
            <Routes>
                <Route path='/' element={<Landing />} />
                <Route path='/horeca' element={<HorecaPage />} />
                <Route path='/sw' element={<Landing />} />
                <Route path='/sw/horeca' element={<HorecaPage />} />
                <Route path='/en' element={<Landing />} />
                <Route path='/en/horeca' element={<HorecaPage />} />
                <Route path='/cookies' element={<CookiePolicyPage />} />
                <Route path='/sw/cookies' element={<CookiePolicyPage />} />
                <Route path='/en/cookies' element={<CookiePolicyPage />} />
                <Route path='*' element={<Landing />} />
            </Routes>
        </BrowserRouter>
    )
}
